module.exports = __webpack_public_path__ + "img/trojan.3abe1338.jpg";